export const SCORE_DETAIL_SCHEMA = {
  scoreTypeName: {
    label: '评分卡名称',
  },
  companyName: {
    label: '客户名称',
  },
  companyCode: {
    label: '客户编号',
  },
  createTime: {
    label: '运行时间',
  },
  reportTime: {
    label: '财报时间',
  },
  operator: {
    label: '操作人',
  },
  manualTime: {
    label: '最近一次人工调整时间',
  },
  manualUser: {
    label: '调整人',
  },
  manualRemark: {
    label: '人工调整备注',
  },
}
